import { render, staticRenderFns } from "./FarmGoodsFlow.vue?vue&type=template&id=07e27d4a&scoped=true&"
import script from "./FarmGoodsFlow.vue?vue&type=script&lang=js&"
export * from "./FarmGoodsFlow.vue?vue&type=script&lang=js&"
import style0 from "./FarmGoodsFlow.vue?vue&type=style&index=0&id=07e27d4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e27d4a",
  null
  
)

export default component.exports